class Errors {
    /**
     * Create a new Errors instance.
     */
    constructor() {
        this.errors = {};
    }


    /**
     * Get the property name from its parts.
     *
     * @param {string} field
     * @param {string|null} index, if part of array
     * @param {string|null} key, if the previous array is an object
     */
    property(field, index = null, key = null) {
        let property = field;

        if(index !== null) {
            property += '.' + index;

            if(key !== null) {
                property += '.' + key;
            }
        }

        return property;
    }


    /**
     * Determine if an errors exists for the given field.
     *
     * @param {string} field
     * @param {string|null} index, if part of array
     * @param {string|null} key, if the previous array is an object
     */
    has(field, index = null, key = null) {
        const property = this.property(field, index, key);

        return this.errors.hasOwnProperty(property);
    }


    /**
     * Determine if there is any errors.
     */
    any() {
        return Object.keys(this.errors).length > 0;
    }


    /**
     * Retrieve the error message for a field.
     *
     * @param {bool} if a boolean is needed as the return value
     * @param {string} field
     * @param {string|null} index, if part of array
     * @param {string|null} key, if the previous array is an object
     */
    get(retBool, field, index = null, key = null) {
        const property = this.property(field, index, key);

        if(this.errors[property]) {
            if('string' === typeof(this.errors[property])) {
                return this.errors[property];
            }
            else {
                return this.errors[property][0];
            }
        }

        if(retBool) {
            return true;
        }
        else {
            return;
        }
    }


    /**
     * Record the new errors.
     *
     * @param {object} errors
     * @param {string|null} field if only one is being added
     * @param {string|null} index, if part of array
     * @param {string|null} key, if the previous array is an object
     */
    record(errors, field = null, index = null, key = null) {
        if(field) {
            const property = this.property(field, index, key);

            // Maldito problema do Vue com arrays...
            // https://vuejs.org/v2/guide/list.html#Caveats
            Vue.set(this.errors, property, errors);
        }
        else {
            this.errors = errors;
        }
    }


    /**
     * Clear one or all error fields.
     *
     * @param {string|null} field
     * @param {string|null} index, if part of array
     * @param {string|null} key, if the previous array is an object
     * @param {bool|false} if an array is given, adjusts the remaining elements accordingly
     */
    clear(field = null, index = null, key = null, replace = false) {
        if(field) {
            const property = this.property(field, index, key);

            // Maldito problema do Vue com arrays...
            // https://vuejs.org/v2/api/#Vue-delete
            Vue.delete(this.errors, property);

            if(replace) {
                let re;

                if(key) {
                    re = new RegExp(field + '\\.([0-9]+)\\.' + key);
                }
                else {
                    re = new RegExp(field + '\\.([0-9]+)');
                }

                for(const oldKey in this.errors) {

                    if(oldKey.search(re) === 0) {
                        const newId = re.exec(oldKey)[1] - 1; // re group #1 -> subtract 1 from the result

                        if(newId >= index) {
                            const newKey = this.property(field, newId, key);

                            this.errors[newKey] = this.errors[oldKey];
                            Vue.delete(this.errors, oldKey);
                        }
                    }
                }
            }
        }
        else {
            this.errors = {};
        }
    }
}

export default Errors;
